/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateFilterComponent} from './date-filter.component';
import {NgbDatepickerModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {TooltipModule} from '../../tooltip/tooltip.module';
import {FilterFooterModule} from '../filter-footer/filter-footer.module';
import {InputModule} from '../../input/input.module';

@NgModule({
    declarations: [DateFilterComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        TooltipModule,
        FilterFooterModule,
        InputModule
    ],
    exports: [DateFilterComponent]
})
export class DateFilterModule {
}
